module.exports = __webpack_public_path__ + "media/images/forest-0e8b20c32997555652ab90bf4fb604eb.mp4";